module.exports = __webpack_public_path__ + "static/media/bookr-logo.9298a70e.svg";